import {
  shape, bool, arrayOf, string, func, oneOfType, number,
} from 'prop-types';

export const propTypes = {
  session: shape(),
  loading: shape({
    charts: bool,
  }),
  chart: shape({
    list: arrayOf(shape()),
    onDelete: func,
    onClick: func,
    selected: shape(),
  }),
  list: arrayOf(shape({
    name: oneOfType([number, string]),
  })),
  onTableCellTitleClick: func,
  listTotal: number,
};

export const defaultProps = {
  session: {},
  loading: {
    charts: false,
  },
  chart: {
    list: [],
    selected: {},
    onClick: null,
    onDelete: null,
  },
  list: [],
  listTotal: 0,
  onTableCellTitleClick: null,
};

export default {
  propTypes,
  defaultProps,
};
